var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProductOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35352 8H4.35352V11H6.35352V8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3535 8H10.3535V11H12.3535V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.35352 0C6.14438 0 4.35352 1.79086 4.35352 4H0.354487L0.0361454 14.8236C-0.0201172 16.7365 -0.0482485 17.693 0.24549 18.4489C0.637142 19.4567 1.42012 20.2631 2.41601 20.6842C3.16292 21 4.1198 21 6.03355 21H10.6754C12.5892 21 13.5461 21 14.293 20.6842C15.2889 20.2631 16.0718 19.4567 16.4635 18.4489C16.7572 17.693 16.7291 16.7365 16.6728 14.8236L16.3545 4H12.3535C12.3535 1.79086 10.5627 0 8.35352 0ZM8.35352 2C7.24895 2 6.35352 2.89543 6.35352 4H10.3535C10.3535 2.89543 9.45809 2 8.35352 2ZM2.29653 6L2.03528 14.8824C2.00633 15.8666 1.98872 16.5034 2.008 16.9911C2.0266 17.4614 2.0769 17.6401 2.10968 17.7244C2.3055 18.2284 2.69699 18.6315 3.19493 18.8421C3.27828 18.8773 3.45545 18.9329 3.92497 18.9653C4.4119 18.9989 5.04891 19 6.03355 19H10.6754C11.6601 19 12.2971 18.9989 12.784 18.9653C13.2535 18.9329 13.4307 18.8773 13.514 18.8421C14.012 18.6315 14.4035 18.2284 14.5993 17.7244C14.6321 17.6401 14.6824 17.4614 14.701 16.9911C14.7203 16.5034 14.7026 15.8666 14.6737 14.8824L14.4124 6H2.29653Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductOutline);
export default __webpack_public_path__ + "static/media/productOutline.15fd4a188640b19b2893d06acc243d1c.svg";
export { ForwardRef as ReactComponent };